import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
    getConferenceAgendaApi,
    createConferenceAgendaApi,
    updateConferenceAgendaApi,
    deleteConferenceAgendaApi,
} from "./conferenceAgendaApi";

export const getConferenceAgenda = createAsyncThunk(
    "conferenceAgenda/getConferenceAgenda",
    async ({ page, limit, search, locationId }, thunkAPI) => {
        try {
            const res = await getConferenceAgendaApi({
                page,
                limit,
                search,
                locationId,
            });
            return res.data.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(
                err.response?.data?.message || "Failed to fetch agenda"
            );
        }
    }
);

export const createConferenceAgenda = createAsyncThunk(
    "conferenceAgenda/createConferenceAgenda",
    async (data, thunkAPI) => {
        try {
            const res = await createConferenceAgendaApi(data);
            return res.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data);
        }
    }
);

export const updateConferenceAgenda = createAsyncThunk(
    "conferenceAgenda/updateConferenceAgenda",
    async ({ id, data }, thunkAPI) => {
        try {
            const res = await updateConferenceAgendaApi(id, data);
            return res.data;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data);
        }
    }
);

export const deleteConferenceAgenda = createAsyncThunk(
    "conferenceAgenda/deleteConferenceAgenda",
    async (id, thunkAPI) => {
        try {
            await deleteConferenceAgendaApi(id);
            return id;
        } catch (err) {
            return thunkAPI.rejectWithValue(err.response?.data);
        }
    }
);

const slice = createSlice({
    name: "conferenceAgenda",
    initialState: {
        agenda: [],
        total: 0,
        loading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getConferenceAgenda.pending, (state) => {
                state.loading = true;
            })
            .addCase(getConferenceAgenda.fulfilled, (state, action) => {
                state.loading = false;
                state.agenda = action.payload?.items || [];
                state.total = action.payload?.total || 0;
            })
            .addCase(getConferenceAgenda.rejected, (state) => {
                state.loading = false;
            })

            .addCase(deleteConferenceAgenda.fulfilled, (state, action) => {
                state.agenda = state.agenda.filter(
                    (item) => item.id !== action.payload
                );
            });
    },
});

export default slice.reducer;